import { Divider, IconButton, ListItemText, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { type MouseEvent as ReactMouseEvent, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/form'
import { EntityTypesContext } from '../../io/context/EntityTypes'
import useEntityRepository from '../../io/useEntityRepository'
import EntityWithLabelAndRelated from '../../domain/entity/EntityWithLabelAndRelated'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityId = com.eidu.sharedlib.entity.EntityId

type ActionsMenuProps = {
  userEntityId: EntityId | undefined
  signOut?: () => void
}

const ActionsMenu = ({ userEntityId, signOut }: ActionsMenuProps) => {
  const navigate = useNavigate()
  const entityTypes = useContext(EntityTypesContext).useAll()
  const entityRepository = useEntityRepository(
    { typeId: undefined, types: entityTypes ?? new Map<EntityTypeId, EntityType>() },
    [entityTypes]
  )

  const [userEntity, setUserEntity] = useState<EntityWithLabelAndRelated>()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  useEffect(() => {
    if (userEntityId)
      entityRepository.get(userEntityId).then((entity) => {
        if (entity !== null) setUserEntity(entity)
      })
  }, [userEntityId, entityRepository])

  const close = () => setAnchorEl(null)
  const open = (event: ReactMouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)

  const openCurrentUser = () => {
    if (!userEntity) return
    close()
    navigate(`/entities/${userEntity.entity.typeId.toString()}/view/${userEntity.entity.id.toString()}`)
  }

  if (!userEntity && !signOut) return null

  return (
    <>
      <IconButton edge="end" color="inherit" aria-label="Open user actions menu" onClick={open}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        {userEntity && (
          <MenuItem onClick={openCurrentUser}>
            <ListItemText
              primary="Your Profile"
              secondary={userEntity.primaryLabelText || userEntity.entity.id.toString()}
            />
          </MenuItem>
        )}
        {userEntity && signOut && <Divider />}
        {signOut && (
          <MenuItem
            onClick={() => {
              close()
              signOut()
            }}
          >
            Log out
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default ActionsMenu
